// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_1-H","col":"styles_col__30cpn","actions":"styles_actions__3paDt","conflict":"styles_conflict___mE0Z"};